<script>
  export let id;

  import Menu from "../components/Menu.svelte";
  import Breadcrumbs from "../components/Breadcrumbs.svelte";
  import Footer from "../components/Footer.svelte";
  import LogItem from "../components/LogItem.svelte";

  import { dictionary } from "../utils/stores.js";
  import { getToken, redirectIfNotToken } from "../utils/token.js";
  import { post } from "../utils/api.js";

  import { onMount } from "svelte";

  redirectIfNotToken("/login");

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  const pageName = "revisor";

  let logs = [];
  let nombreApellidos = "";

  onMount(async () => {
    obtenerNombreApellidos();
    listarLog();
  });

  let listarLog = async () => {
    logs = await post(
      "HistorialRevisor",
      {
        token: getToken(),
        id
      },
      "json"
    );
  };

  let obtenerNombreApellidos = async () => {
    nombreApellidos = await post(
      "ObtenerNombreApellidos",
      {
        token: getToken(),
        id_usuario: id
      },
      "text"
    );
    nombreApellidos = nombreApellidos
      .replace(/\\/g, "")
      .replace(/"/g, "")
      .trim();
  };
</script>

<div class="ie-panel">
  <a href="http://windows.microsoft.com/en-US/internet-explorer/">
    <img
      src="images/ie8-panel/warning_bar_0000_us.jpg"
      height="42"
      width="820"
      alt="You are using an outdated browser. For a faster, safer browsing
      experience, upgrade for free today." />
  </a>
</div>
<div class="preloader" id="loading">
  <div class="preloader-body">
    <div id="loading-center-object">
      <div class="object" id="object_four" />
      <div class="object" id="object_three" />
      <div class="object" id="object_two" />
      <div class="object" id="object_one" />
    </div>
  </div>
</div>
<div class="page">

  <!-- Menu -->

  <Menu {pageName} />

  <!-- Breadcrumbs -->

  <Breadcrumbs pageName={dict[pageName]} />

  <!-- Body -->

  <section class="section">
    <div class="container">
      <h3 class="titulo">{dict['historialRevisor']}</h3>
      <h3 class="titulo subtitulo">{nombreApellidos}</h3>
      <table class="logs">
        {#each logs as log}
          <LogItem {log} />
        {/each}
      </table>
    </div>
  </section>
  <Footer />
</div>
<div class="snackbars" id="form-output-global" />
